import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
} from '@mantine/core';
import { themeColors } from '../../config/themeSettings';

const PaharganjSpaRaid = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        November 06, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          Delhi's Paharganj spa immoral trafficking racket busted via 'Say Help' app alert
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Image src="https://www.tribuneindia.com/sortd-service/imaginary/v22-01/jpg/large/high?url=dGhldHJpYnVuZS1zb3J0ZC1wcm8tcHJvZC1zb3J0ZC9tZWRpYTZhNGNkNjMwLWJhZGItMTFmMC1iMDY0LWVkNWUyYTYzNDljNy5qcGc=" />
          <div className={classes.imageAttribution}>
            Image from Tribune India
          </div>

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              <strong>NEW DELHI:</strong> Police busted an immoral trafficking racket operating under the guise of a spa in Delhi's Paharganj area after receiving a real-time alert through the 'Say Help' app, officials said on Thursday.
            </Text>
            <Space h="md" />
            <Text>
              Six women were rescued and a woman accused of managing the illicit activity was arrested.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Alert
            </Title>
            <Space h="md" />
            <Text>
              Officials said the alert was received via the 'Say Help' app on the intervening night of October 30-31, flagging suspected immoral activities at Galaxy Spa, located on the 2nd floor of a building near Today Hotel on DBG Road, Nabi Karim.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Operation
            </Title>
            <Space h="md" />
            <Text>
              Deputy Commissioner of Police (Central) Nidhin Valsan said that after the tip-off, a strategic decoy operation was planned. A cop posing as a customer entered the premises with Rs 2,000 in pre-noted currency and was instructed to signal via a missed call once illegal activities were confirmed.
            </Text>
            <Space h="md" />
            <Text>
              Around 7:25 pm, the decoy confirmed the offence, prompting the raiding team to enter the spa, the DCP mentioned.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Raid and Arrests
            </Title>
            <Space h="md" />
            <Text>
              During the raid, six women and a female receptionist, aged 36 and a resident of Paharganj, were found involved in immoral trafficking, Valsan said.
            </Text>
            <Space h="md" />
            <Text>
              Police seized Rs 2,000 in marked currency and three sealed packets of condoms from the site. Preliminary interrogation revealed that the woman was operating the spa with her husband, the officer added.
            </Text>
            <Space h="md" />
            <Text>
              A case under Sections 3, 4, and 5 of the Immoral Traffic (Prevention) Act, 1956 has been registered at Nabi Karim Police Station.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Rescued Women
            </Title>
            <Space h="md" />
            <Text>
              The rescued women, aged between 21 and 34, hailed from West Bengal, Jharkhand, Uttar Pradesh, and Delhi, Valsan further mentioned.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              About Say Help App
            </Title>
            <Space h="md" />
            <Text>
              The 'Say Help' app, a voice-activated emergency platform designed for women's and public safety, immediately facilitated coordination between the app's monitoring team and the police.
            </Text>
            <Space h="md" />
          </section>
          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor href="https://www.tribuneindia.com/author/tribune-news-service" target="_blank">
              Tribune News Service
            </Anchor>
            . Source:{' '}
            <Anchor href="https://www.tribuneindia.com/news/nation/delhis-paharganj-spa-immoral-trafficking-racket-busted-via-say-help-app-alert" target="_blank">
              Tribune India
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default PaharganjSpaRaid;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  titleLeft: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
